export default {
  clovers: "Fiori",
  tiles: "Quadri",
  hearts: "Cuori",
  pikes: "Picche"
};



// WEBPACK FOOTER //
// ./src/card-names.js